import { QuizDraft, QuizQuestion } from '../typings';

export const getEmptyQuizQuestion = (): QuizQuestion => ({
    title: '',
    answers: [
        {
            value: '',
            correct: false,
        },
        {
            value: '',
            correct: false,
        },
        {
            value: '',
            correct: false,
        },
        {
            value: '',
            correct: false,
        },
    ],
});

export const getEmptyQuizTemplate = (id?: string): QuizDraft => {
    const questionTemplate = getEmptyQuizQuestion();

    return {
        title: '',
        subject: '',
        questions: [questionTemplate],
        id,
    };
};
